import React from 'react';
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";
import heroVideo from "@/assets/hero-background-video.mp4";

const HeroSection = () => {
  const { t } = useTranslation();
  
  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Video with Overlay */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        src={heroVideo}
      >
        Your browser does not support the video tag.
      </video>
      <div className="absolute inset-0 bg-gradient-overlay"></div>
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 text-center text-enausa-text-on-navy pt-20">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold mb-6 leading-tight px-2">
            <span className="block text-enausa-gold-light drop-shadow-lg [text-shadow:_2px_2px_4px_rgb(0_0_0_/_50%)]">ENAUSA</span>
            <span className="block text-enausa-text-on-navy drop-shadow-md">Infraestructura</span>
          </h1>
          
          <p className="text-lg sm:text-xl md:text-2xl mb-8 text-enausa-text-on-navy/80 max-w-3xl mx-auto leading-relaxed">
            {t('hero.subtitle')}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center px-4">
            <Button 
              variant="enausa" 
              size="xl" 
              className="w-full sm:w-auto bg-gradient-primary text-enausa-text-on-navy shadow-strong hover:shadow-strong hover:scale-[1.02] focus-visible:ring-enausa-gold-dark"
              onClick={() => document.getElementById('servicios')?.scrollIntoView({ behavior: 'smooth' })}
            >
              {t('nav.services')}
            </Button>
            <Button
              variant="enausa-outline"
              size="xl"
              className="w-full sm:w-auto border-enausa-text-on-navy text-enausa-text-on-navy bg-enausa-text-on-navy/10 backdrop-blur-sm hover:bg-enausa-text-on-navy hover:text-enausa-navy"
              onClick={() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' })}
            >
              {t('hero.cta')}
            </Button>
          </div>
          
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 max-w-4xl mx-auto px-4">
            <div className="text-center">
              <div className="text-2xl sm:text-3xl font-bold text-enausa-gold-light mb-2">{t('hero.team')}</div>
              <p className="text-sm sm:text-base text-enausa-text-on-navy/70">{t('hero.teamDesc')}</p>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl font-bold text-enausa-gold-light mb-2">3+</div>
              <p className="text-sm sm:text-base text-enausa-text-on-navy/70">{t('hero.coverage')}</p>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl font-bold text-enausa-gold-light mb-2">99%</div>
              <p className="text-sm sm:text-base text-enausa-text-on-navy/70">{t('hero.projects')}</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-enausa-text-on-navy animate-bounce">
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;